import React from 'react';
import PropTypes from 'prop-types';

const Quality = ({ title, contentHTML }) => {
  return (
    <div>
      <center>
        <h3 style={{ fontWeight: 'bold', marginBottom: 20 }}>{title}</h3>
      </center>
      <div
        style={{
          margin: '0 0 30px 0',
          fontFamily: 'Roboto',
          fontSize: '20px',
          textAlign: 'justify',
          color: '#787878',
        }}
        dangerouslySetInnerHTML={{ __html: contentHTML }}
      />
    </div>
  );
};

Quality.propTypes = {
  title: PropTypes.string.isRequired,
  contentHTML: PropTypes.string.isRequired,
};

export default Quality;



// WEBPACK FOOTER //
// ./src/components/Main/about/Quality.js